export default {
  // ギフトタイプ：1=実物ギフト，2=バーチャルギフト
  giftType: {
    1: '実物ギフト',
    2: 'バーチャルギフト',
  },
  // スペックタイプ：1=単一スペック，2=複数スペック
  specType: {
    1: '単一スペック',
    2: '複数スペック',
  },
  // 公開状態：0=非公開，1=公開
  publishStatus: {
    0: '公開停止',
    1: '公開中',
  },
  // 注文状態
  orderStatus: {
    0: '処理待ち',
    1: '交換済み',
    2: '発送済み',
    3: '完了',
    4: 'キャンセル',
    5: '失敗',
  },
  // 発送状態：1=発送待ち，2=発送済み，3=完了
  shippingStatus: {
    1: '発送待ち',
    2: '発送済み',
    3: '完了',
  },
  // アカウント状態
  accountStatus: {
    0: '無効',
    1: '有効',
  },
  // アカウントタイプ
  accountType: {
    1: 'メインアカウント',
    2: 'サブアカウント',
  },
  // 暗号化プロトコル
  encryption: {
    ssl: 'SSL',
    tls: 'TLS',
    none: 'None',
  },
  // 素材タイプ
  materialType: {
    image: '画像',
    video: '動画',
  },
  // スキャン回数
  scanCount: {
    first: '初回',
    repeated: 'リピートスキャン',
  },
  // デフォルトテンプレート
  isDefault: {
    on: 'オン',
    off: 'オフ',
  },
};
